import React from 'react';

/** VITE_APP_ENV is baked in at build time (Dockerfile.backend ARG); 'preview' on PR previews / staging. */
function buildAppEnv(): string | undefined {
  return (import.meta as unknown as { env?: Record<string, string | undefined> }).env?.VITE_APP_ENV;
}

/**
 * A small fixed "Preview environment" tag on every page (office and field) of a
 * preview build, so nobody mistakes it for the live site. Renders nothing otherwise.
 */
export function PreviewBanner({ appEnv = buildAppEnv() }: { appEnv?: string }) {
  if (appEnv !== 'preview') {return null;}
  return (
    <div
      role="status"
      data-testid="preview-banner"
      className="fixed bottom-2 left-2 z-[9999] rounded bg-amber-500 px-2 py-1 text-xs font-semibold text-black shadow pointer-events-none"
    >
      Preview environment
    </div>
  );
}
